export interface Appointment {
  id: string;
  title: string;
  doctor: string;
  specialty: string;
  date: string;
  time: string;
  location: string;
  type: string;
  status: string;
  notes?: string;
  duration: number;
  providerId: string;
  patientId: string;
  reminderSent: boolean;
  dataExportPrepared: boolean;
}

export const exampleAppointments: Appointment[] = [
  {
    id: '1',
    title: 'Diabetes Follow-up',
    doctor: 'Dr. Sarah Smith',
    specialty: 'Endocrinology',
    date: '2024-01-18',
    time: '14:00',
    location: 'Main Hospital - Room 305',
    type: 'in-person',
    status: 'scheduled',
    notes: 'Bring recent lab results and ZippyHealth data export',
    duration: 30,
    providerId: 'provider-1',
    patientId: 'patient-1',
    reminderSent: true,
    dataExportPrepared: true
  },
  {
    id: '2',
    title: 'Blood Pressure Check',
    doctor: 'Dr. Michael Johnson',
    specialty: 'Cardiology',
    date: '2024-01-22',
    time: '10:30',
    location: 'Cardiology Clinic',
    type: 'in-person',
    status: 'scheduled',
    duration: 20,
    providerId: 'provider-2',
    patientId: 'patient-1',
    reminderSent: false,
    dataExportPrepared: false
  },
  {
    id: '3',
    title: 'Medication Review',
    doctor: 'Dr. Emily Davis',
    specialty: 'Primary Care',
    date: '2024-01-12',
    time: '16:00',
    location: 'Virtual',
    type: 'telemedicine',
    status: 'completed',
    notes: 'Discussed medication adjustments based on ZippyHealth tracking',
    duration: 25,
    providerId: 'provider-3',
    patientId: 'patient-1',
    reminderSent: true,
    dataExportPrepared: true
  },
  {
    id: '4',
    title: 'Annual Physical',
    doctor: 'Dr. Robert Wilson',
    specialty: 'Family Medicine',
    date: '2024-02-05',
    time: '09:00',
    location: 'Family Health Center',
    type: 'in-person',
    status: 'confirmed',
    duration: 45,
    providerId: 'provider-4',
    patientId: 'patient-1',
    reminderSent: true,
    dataExportPrepared: false
  }
]; 